// src/theme/t4rTheme.js
import { createTheme } from "@mui/material/styles";

const t4rTheme = createTheme({
  palette: {
    primary: {
      main: "#000000", // Primary color = black
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ffffff",
    },
    background: {
      default: "#fafafa",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#000000",
          color: "#ffffff",
        },
      },
    },
  },
});

export default t4rTheme;
